export const environment = {
  production: true,
  connection: {
    name: 'Produktiv',
    host: 'https://mde.inn-traun.lagerhaus.at',
    port: 443,
    basePath: '/api'
  },
  theme: undefined,
  androidUpdateRepository: ''
};
